import { FormikHandlers } from 'formik';
import React, { FC } from 'react';
import TextInput from '../../../../library/inputs/text/TextInput';

/*
 ** Component: EmailField
 ** Props
 ** id: field id
 ** enabled: control disabled or not
 ** placeholder: placeholder
 ** value: field value
 ** touched: boolean variable if the field has been touched
 ** error: error string
 ** handleChange: function to handle value
 ** handleBlur: function to handle touched
 */

interface Props {
  id: string;
  enabled: boolean;
  placeholder: string | undefined;
  value: string;
  touched: boolean | undefined;
  error: string | undefined;
  handleBlur: FormikHandlers['handleBlur'];
  handleChange: FormikHandlers['handleChange'];
}

const EmailField: FC<Props> = ({
  id,
  enabled,
  placeholder,
  value,
  touched,
  error,
  handleBlur,
  handleChange,
}: Props) => {
  return (
    <TextInput
      id={id}
      value={value}
      touched={touched}
      error={error}
      enabled={enabled}
      placeholder={placeholder}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
};

export default EmailField;
